/**
 * @file utils/analytics.js
 * @description Google Analytics 4 integration. Provides tracking ID configuration,
 * page view reporting, event tracking, and web vitals metrics reporting.
 */

export const GA_TRACKING_ID = ''; // Set your GA4 tracking ID here (e.g. 'G-XXXXXXXXXX') to enable analytics

// Initialize Google Analytics (only loads if a valid tracking ID is set)
export const initGA = () => {
  if (!GA_TRACKING_ID) return;

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', GA_TRACKING_ID, {
    page_path: window.location.pathname,
  });
};

// Track Page Views
export const pageView = (url) => {
  if (!window.gtag) return;
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

// Track Events
export const event = ({ action, category, label, value }) => {
  if (!window.gtag) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

// Track User Engagement
export const trackEngagement = (type) => {
  event({
    action: 'engagement',
    category: 'User Interaction',
    label: type,
  });
};

// Track Core Web Vitals
export const trackWebVitals = ({ name, delta, id }) => {
  event({
    action: name,
    category: 'Web Vitals',
    label: id,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
  });
};

// Report Web Vitals (for use with web-vitals library)
export const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// Send metrics to analytics
export const sendToAnalytics = ({ name, delta, id }) => {
  // Log to console in development
  if (import.meta.env.DEV) {
    console.log('Web Vital:', { name, delta, id });
  }
  
  // Send to Google Analytics
  trackWebVitals({ name, delta, id });
}; 